import crud from '@/crud/index/index'
import resources from '../../resources'

import components from './components'

export default {
  components,
  resourcePath: '/v1/patient/settings/dependents',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/index/resources/index.js